import { render, staticRenderFns } from "./ModalActivacioEnquesta.vue?vue&type=template&id=2b8fe5e4&"
import script from "./ModalActivacioEnquesta.vue?vue&type=script&lang=js&"
export * from "./ModalActivacioEnquesta.vue?vue&type=script&lang=js&"
import style0 from "./ModalActivacioEnquesta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports